import { StyledEngineProvider, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import { useEffect } from 'react';
import { QueryClientProvider } from 'react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from './api/queryClient';
import { ThemeProvider } from './components/ThemeProvider/ThemeProvider';
import routes from './route';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-error': {
    backgroundColor: '#FF5F57',
  },
}));

const App = () => {
  useEffect(() => {
    window.addEventListener('keydown', function (e) {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) {
        e.preventDefault();
      }
    });
  }, []);

  return (
    <ThemeProvider mode={'light'}>
      <SnackbarProvider
        Components={{
          error: StyledMaterialDesignContent,
        }}
      />
      <StyledEngineProvider injectFirst>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={routes} />
        </QueryClientProvider>
      </StyledEngineProvider>
    </ThemeProvider>
  );
};

export default App;
